var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCustom = function SvgCustom(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 -960 960 960"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M450.001-130.001v-219.998h59.998v80h320v59.998h-320v80zm-320-80v-59.998h219.998v59.998zm160-160v-80h-160v-59.998h160v-80h59.998v219.998zm160-80v-59.998h379.998v59.998zm160-160v-219.998h59.998v80h160v59.998h-160v80zm-480-80v-59.998h379.998v59.998z"
  })));
};
export default SvgCustom;